/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartHeader").classList.remove("active");
    document.querySelector("#miniCartAnnouncement")?.classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartUpsell").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    /*************************
     Start Free Items
     **************************/

        // create update payload
    let updatePayload = {};

    // remove vitamin d+k if in cart
    const freeGifts = cart.items.filter(item => item.handle === "vitamin-d-k" || item.handle === "water-bottle-mvp" || item.handle === "3-pack-variety-pack");
    if (freeGifts.length > 0) {
        // get all protection items
        freeGifts.forEach(item => {
            updatePayload[item.key] = 0;
        });
    }

    // check if we need to update the cart
    if (Object.keys(updatePayload).length > 0) {
        cart = await updateCart({updates: updatePayload});
        await openCart(true);
        return;
    }

    // determine total number of premium-electrolyte-drink-mix
    let premiumElectrolyteDrinkMixCount = 0;
    let hasSubscription = false;
    cart.items.forEach(item => {
        if (item.handle === "premium-electrolyte-drink-mix") {
            premiumElectrolyteDrinkMixCount += item.quantity;
        }
        if (item.selling_plan_allocation) {
            hasSubscription = true;
        }
    });

    // hide all free gifts
    document.querySelectorAll(".miniCartBodyItem.gift").forEach(element => element.classList.remove("active"));

    // if 4 or more, add all gifts, if one sub, add sampler
    if (premiumElectrolyteDrinkMixCount >= 4) {
        if (vitamins) {
            document.querySelector("#miniCartBodyGift90").classList.add("active");
        } else {
            document.querySelector("#miniCartBodyGiftSampler").classList.add("active");
        }
        if (bottle) {
            document.querySelector("#miniCartBodyGiftWaterBottle").classList.add("active");
        }
    } else if (premiumElectrolyteDrinkMixCount >= 1 && hasSubscription) {
        document.querySelector("#miniCartBodyGiftSampler").classList.add("active");
    }

    /*************************
     Finish Free Items
     **************************/

    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    if (cart.item_count !== 0) {
        document.querySelector('#headerCartNumber').textContent = cart.item_count < 10 ? "0" + cart.item_count.toString() : cart.item_count.toString();
        document.querySelector("#miniCartHeaderTitle").textContent = `Your Cart (${cart.item_count})`;
    }

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector('#headerCartNumber').textContent = "0";
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartAnnouncement")?.classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem:not(.gift)").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    let text = ""
                    if (key === "_gift_image") {
                        text = "Gift Image";
                    } else {
                        text = item.properties[key];
                    }
                    HTML += `<a href="${item.properties[key]}" target="_blank">${text}</a><br>`;
                    continue;
                }

                // hide some lines
                if (key.includes("_")) continue;

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (cartData[item.key] && cartData[item.key].compare_at_price > item.final_price) {
                comparePrice = cartData[item.key].compare_at_price * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, false)}</s>`;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            /***************** savings *****************/

            // check for savings
            if (comparePrice) {
                let savings = comparePrice - item.final_line_price;
                if (savings > 0) {
                    HTML += `<span>(Save ${price(savings, false)})</span>`;
                }
            }

            return HTML;
        }

        // check if item is a free gift
        const freeGiftItem = item.final_line_price === 0;

        // upgrade button HTML
        function upgradeHTML() {
            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // check if it's a free gift
            if (freeGiftItem) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = null;
            if (cartData[item.key]) {
                sellingPlanID = cartData[item.key].selling_plan_id;
            }

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            let subscribeButtonText = "Upgrade to Subscription";
            if (cartData[item.key].upgrade_to_subscription_label) {
                subscribeButtonText = cartData[item.key].upgrade_to_subscription_label;
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-id="${item.variant_id}" 
                     data-plan="${sellingPlanID}"
                     data-quantity="${item.quantity}"
                >
                    ${subscribeButtonText}
                </button>
                <p class="miniCartBodyItemUpgradeTag">&#128666; Free Shipping with Subscribe & Save &#128666;</p>
            `;
        }

        // check for alternate image
        let imageSource = item.image;
        if (cartData[item.key] && cartData[item.key].image) {
            imageSource = cartData[item.key].image;
        }

        // create quantity element so it can be disabled for free products
        function quantityElement() {
            if (freeGiftItem) {
                return `
                    <div class="miniCartBodyItemQuantityCount noChange">${item.quantity}</div>
                `;
            }

            return `
                <button class="miniCartBodyItemQuantityMinus">-</button>
                <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                <button class="miniCartBodyItemQuantityPlus">+</button>
            `;
        }

        // create delete element so it can be disabled for free products
        function deleteElement() {
            if (freeGiftItem) return '';
            return `
                <button class="miniCartBodyItemRemove">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.34375 3.28125H12.6562H2.34375Z" fill="#8F8F8F"></path><path d="M2.34375 3.28125H12.6562" stroke="#8F8F8F" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"></path><path d="M9.60938 5.15625L9.375 11.7188M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67693 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67693 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125H5.625ZM7.5 5.15625V11.7188V5.15625ZM5.39062 5.15625L5.625 11.7188L5.39062 5.15625Z" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </button>
            `
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${imageSource}&width=200" alt="${item.title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                        ${deleteElement()}
                    </div>
                    <div class="miniCartBodyItemFlex">
                    <div class="miniCartBodyItemQuantity">
                            ${quantityElement()}
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount")?.textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus")?.addEventListener("click", function () {
            // prevents loading issues when too many clicks
            this.parentElement.classList.add('disable');
            if (quantity <= 0) return;
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus")?.addEventListener("click", function () {
            this.parentElement.classList.add('disable');
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove")?.addEventListener("click", function () {
            this.parentElement.classList.add('disable');
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeCart({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const variantID = parseInt(this.dataset.id);
            const sellingPlanID = parseInt(this.dataset.plan);
            const quantity = parseInt(this.dataset.quantity);

            // add loading animation
            this.classList.add("loading");

            // remove this product from the cart
            await changeCart({
                id: key,
                quantity: 0,
            });

            // add new product to cart (note, we don't change since we have a custom atc function)
            await addProduct({
                items: [{
                    quantity: quantity,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            });

            await openCart();

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem")?.forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell")?.classList.remove("active");
    }

    // update price
    document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price);
}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC')?.forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // add loading animation
        this.classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});


// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});


// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// check if we are using vitamins or 3 pack for free gift
const vitamins = document.querySelector('#miniCart').classList.contains('vitamins');
const bottle = document.querySelector('#miniCart').classList.contains('bottle');

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // determine total number of premium-electrolyte-drink-mix
    let premiumElectrolyteDrinkMixCount = 0;
    let hasSubscription = false;
    cart.items.forEach(item => {
        if (item.handle === "premium-electrolyte-drink-mix") {
            premiumElectrolyteDrinkMixCount += item.quantity;
        }
        if (item.selling_plan_allocation) {
            hasSubscription = true;
        }
    });

    // add all gifts if 4 or more items
    if (premiumElectrolyteDrinkMixCount >= 4) {
        const add = [];
        if (bottle) {
            add.push({
                id: waterBottleVariantID,
                quantity: 1
            })
        }
        if (vitamins) {
            add.push({
                id: vitamins90VariantID,
                quantity: 1
            })
        } else {
            add.push({
                quantity: 1,
                id: samplerVariantID,
            })
        }
        await addProduct({
            items: add
        });
    } else if (premiumElectrolyteDrinkMixCount >= 1 && hasSubscription) {
        // add a sampler pack if there is a subscription
        await addProduct({
            items: [{
                quantity: 1,
                id: samplerVariantID,
            }]
        });
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}

// refresh cart every 2 seconds while the cart isn't open
setInterval(async function () {
    if (!document.querySelector("#miniCart[open]")) {
        cart = await getCart();
    }
}, 2000);